<template>
  <div>
    <ValidationObserver ref="form">
      <div class="row mb-3">
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required|onlyNumbers">
            <input
              type="text"
              class="form-control"
              placeholder="CNES"
              v-model="form.cnes"
              v-inputmask="maskNumbers"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="monthOptions"
              label="label"
              placeholder="Mês"
              v-model="form.mes"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required|onlyNumbers">
            <input
              type="text"
              class="form-control"
              placeholder="Ano"
              v-model="form.ano"
              v-inputmask="maskNumbers"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <button class="btn" @click="buscar()">Buscar</button>
        </div>
      </div>
    </ValidationObserver>
    <div class="col-md-12 p-0">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Produção" active @click="buscarDadosDaTabela('producao')">
          <template v-slot:title>
            <i class="icofont-list"></i> Produção
          </template>
        </b-tab>
        <b-tab title="Meta" @click="buscarDadosDaTabela('meta')">
          <template v-slot:title> <i class="icofont-list"></i> Meta </template>
        </b-tab>
      </b-tabs>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div v-if="tabsActive === 1" class="info-table-item">
            <Subtitle
              @exibirVermelhos="handleExibirVermelhos"
              @exibirVerdes="handleExibirVerdes"
            ></Subtitle>
          </div>
          <div v-if="tabsActive === 1" class="info-table-item">
            <vue-select
              :options="typeCeoOptions"
              label="label"
              placeholder="Tipo CEO"
              v-model="form.typeCeo"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="info-table-item">
            <download-files
              :callback-pdf="generatePdf"
              :data="displayedCadastros"
              :fields="tabsActive === 0 ? dataFieldsProduction : dataFieldsMeta"
              :xlsEnabled="true"
              name="CEO"
            >
            </download-files>
          </div>
        </div>
        <tabela-cadastros-vuetfy
          ref="table"
          :cadastros="displayedCadastros"
          :loading="loading"
          :headers="tableSelected"
          @filterSearch="filterSearch($event)"
        ></tabela-cadastros-vuetfy>
      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Subtitle from './Subtitle'
import { dataFieldsMeta, dataFieldsProduction } from './utils.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  name: 'Ceo',
  components: {
    TabelaCadastrosVuetfy,
    Selects,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
    Subtitle,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      if (this.cadastrosOriginais === null) {
        return []
      }
      let cadastroFiltrados
      if (this.tabsActive === 0) {
        this.cadastros = this.cadastrosOriginais.producao
        return this.cadastros
      } else {
        this.cadastros = this.cadastrosOriginais.meta
        this.getCeo()
        cadastroFiltrados = Filter.filtro(
          this.cadastros,
          this.exibirCadastrosVermelhos,
          this.exibirCadastrosVerdes
        )
      }

      if (cadastroFiltrados === undefined) {
        cadastroFiltrados = []
      }
      return cadastroFiltrados
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  data() {
    return {
      dataFieldsProduction: {
        ...dataFieldsProduction,
      },
      dataFieldsMeta: {
        ...dataFieldsMeta,
      },
      tabsActive: 0,
      cod_ibge: '',
      user_id: '',
      equipe: '',
      cadastros: [],
      cadastrosProducao: [],
      cadastrosMeta: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      loading: false,
      equipName: '',
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      typeCeoOptions: [
        { label: 'Tipo I', value: 'ceo_i' },
        { label: 'Tipo II', value: 'ceo_ii' },
        { label: 'Tipo III', value: 'ceo_iii' },
      ],
      month: '',
      disabledMonth: true,
      cadastrosOriginais: null,
      filterSearchTable: false,
      form: {
        cnes: '',
        mes: '',
        ano: '',
        typeCeo: { label: 'Tipo I', value: 'ceo_i' },
      },
      typeTable: 'producao',
      tableSelected: [],
      headerProduction: [
        {
          text: 'SEQUÊNCIA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'sequencia',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'procedimento',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cbo',
        },
        {
          text: 'QUANTIDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
      headerGoal: [
        {
          text: 'CATEGORIA',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'categoria',
        },
        {
          text: 'META',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'meta',
        },
        {
          text: 'PRODUÇÃO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
    }
  },
  mounted() {
    this.tableSelected = this.headerProduction
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    getCurrentMonth() {
      const date = new Date()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return month
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      if (tabsActive === 1) {
        let data = this.cadastrosOriginais.meta
        if (vermelho === true) {
          data = Functions.exibirVermelhos(data)
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosVermelhos = true
        }
        if (verde === true) {
          data = Functions.exibirVerdes(data)
          this.exibirCadastrosVermelhos = false
          this.exibirCadastrosVerdes = true
        }

        this.cadastros = data
        this.cadastrosPdf = this.cadastros
      }
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        /*   this.filtros(true, false) */
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        /*      this.filtros(false, false) */
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        /*   this.filtros(false, true) */
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        /*    this.filtros(false, false) */
        this.exibirCadastrosVerdes = false
      }
    },
    async buscar() {
      this.tabsActive = 0
      this.typeTable = 'producao'
      this.tableSelected = this.headerProduction
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        this.loading = true
        const response = await Functions.getDados(
          this.$store.state.cod_ibge,
          this.form.cnes,
          this.form.mes.value,
          this.form.ano
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastrosProducao = response.producao
          this.cadastrosMeta = response.meta
          if (this.tabsActive === 0) {
            this.cadastros = this.cadastrosProducao
          } else {
            this.cadastros = this.cadastrosMeta
          }

          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
      }

      return
    },
    buscarDadosDaTabela(table) {
      if (this.cadastrosOriginais === null) {
        return
      }
      if (table === 'producao') {
        this.typeTable = 'producao'
        this.cadastros = this.cadastrosProducao
        this.tableSelected = this.headerProduction
        return
      }
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
      this.typeTable = 'meta'
      this.cadastros = this.cadastrosMeta
      this.tableSelected = this.headerGoal
      this.getCeo()
    },
    getCeo() {
      this.cadastros = this.cadastrosOriginais.meta.map((item) => {
        const ceo = this.form.typeCeo.value
        return {
          ...item,
          meta: item[ceo],
        }
      })
    },
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.form.cnes,
        this.form.mes.value,
        this.form.ano,
        this.form.typeCeo.label,
        this.typeTable
      )
    },
  },
}
</script>

<style lang="scss" scoped src="./styles.scss" />
